import logo from './logo.svg';
import './App.css';
import Main from './component/Main'
import Header from './component/Header';
import Footer from './component/Footer';

function App() {
  

  console.log()
  return (
    <div className="App">
      <Header/>
      <Main />
      <Footer/>
    </div>
  );
}

export default App;
